import empresas from './modules/auth/empresas'
import auth from './modules/auth/auth'
import orcamentos from './modules/admin/orcamentos'
import sincronizacoes from './modules/admin/sincronizacoes'
import ccBloqueados from './modules/admin/ccBloqueados'
import periodosAnaliseOrcamentaria from './modules/admin/periodosAnaliseOrcamentaria'
import periodosEventos from './modules/admin/periodosEventos'
import nomesEventos from './modules/admin/nomesEventos'
import usuarios from './modules/admin/usuarios'
import permissoes from './modules/admin/permissoes'
import usuariosPermissao from './modules/admin/usuariosPermissao'
import ccPais from './modules/centroCusto/ccPais'
import ccFilhos from './modules/centroCusto/ccFilhos'
import naturezasOrcamentarias from './modules/naturezasOrcamentarias/naturezasOrcamentarias'
import registros from './modules/registros/registros'
import memoriasCalculos from './modules/registros/memoriasCalculos'
import upload from './modules/registros/upload'
import metas from './modules/metas/metas'
import receitas from './modules/receitas/receitas'
import eventos from './modules/eventos/eventos'
import analiseOrcamentaria from './modules/analiseOrcamentaria/analiseOrcamentaria'
import codigosOrcamentarios from './modules/relatorios/codigosOrcamentarios'
import relatorios from './modules/relatorios/relatorios'
import embeds from './modules/embeds/embeds'

export default {
  empresas,
  auth,
  orcamentos,
  sincronizacoes,
  ccBloqueados,
  periodosAnaliseOrcamentaria,
  periodosEventos,
  nomesEventos,
  usuarios,
  permissoes,
  usuariosPermissao,
  ccPais,
  ccFilhos,
  naturezasOrcamentarias,
  registros,
  memoriasCalculos,
  upload,
  metas,
  receitas,
  eventos,
  analiseOrcamentaria,
  codigosOrcamentarios,
  relatorios,
  embeds,
}
